import axios from 'axios';
import ErrorWithCause from '../helpers/ErrorWithCause';
import { SYMFONY_API_BASE_URL } from '../config/apiConfig';
const getSummaryStatistics = async ({ userHandle }) => {
    const requestUrl = userHandle ? `${SYMFONY_API_BASE_URL}/api/user/profile_summary/${userHandle}/v1` : `${SYMFONY_API_BASE_URL}/api/user/profile_summary/v1`;
    try {
        const response = await axios.get(requestUrl);
        return response.data;
    }
    catch (error) {
        throw new ErrorWithCause(error);
    }
};
export default getSummaryStatistics;
